import { debounce } from "lodash";
import * as React from "react";
import { FC, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import { actions, Form } from "react-redux-form";
import { useParams } from "react-router";
import Alert from "react-s-alert";
import { bindActionCreators } from "redux";
import {
    TrialInstitutionLaboratoryPersonnelBreadcrumbs,
    TrialInstitutionLaboratoryPersonnelCreateBreadcrumbs,
} from "src/helpers/breadcrumbHelper";
import useNavigate from "src/hooks/useNavigate";
import { ITrialInstitutionLaboratoryPersonnelReduxFormState } from "src/reducers/reactReduxForms/trialInstitutionLaboratoryPersonnel";
import * as NavigationActions from "../../../actions/navigation";
import * as TrialInstitutionLaboratoryPersonnelActions from "../../../actions/trialInstitutionLaboratoryPersonnels";
import { NotificationAlert } from "../../../components/common/index";
import { DatePickerFormInputFabric, SelectFormInput } from "../../../components/form/index";
import { RestrictedLayout } from "../../../components/layouts/index";
import { FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import { createPersonnelSearchLoader } from "../../../functions/personnel";
import { renderRegistrationFormSaveBlock } from "../../../helpers/alert";
import * as AuthenticationHelper from "../../../helpers/authentication";
import { RegistrationComponent, renderFormControls } from "../../../helpers/formHelper";
import { findLookup, generateOptionsFromLookup } from "../../../helpers/lookupHelper";
import { TrialInstitutionLabPersonnelSubMenu } from "../../../helpers/subMenuHelper";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { ITmdState } from "../../../reducers/index";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";

import "./TrialInstitutionLaboratoryPersonnelPage.scss";

interface TrialInstitutionLaboratoryPersonnelPageProps {
    form: Dtos.TrialInstitutionLaboratoryPersonnel & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: ITrialInstitutionLaboratoryPersonnelReduxFormState;
    trialInstitutionLaboratoryPersonnel: Dtos.TrialInstitutionLaboratoryPersonnel;
    lookups: Dtos.Lookup[];
    loadingTrialInstitutionLaboratoryPersonnel: boolean;
    loadTrialInstitutionLaboratoryPersonnelSuccess: boolean;
    loadTrialInstitutionLaboratoryPersonnelFailure: boolean;
    loadTrialInstitutionLaboratoryPersonnelErrorCode: string;
    savingTrialInstitutionLaboratoryPersonnel: boolean;
    saveTrialInstitutionLaboratoryPersonnelSuccess: boolean;
    saveTrialInstitutionLaboratoryPersonnelFailure: boolean;
    creatingTrialInstitutionLaboratoryPersonnel: boolean;
    createTrialInstitutionLaboratoryPersonnelSuccess: boolean;
    createTrialInstitutionLaboratoryPersonnelFailure: boolean;
    validatingTrialInstitutionLaboratoryPersonnel: boolean;
    validationFailures: Dtos.ResponseError[];
    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
    clearTrialInstitutionLaboratoryPersonnel: TrialInstitutionLaboratoryPersonnelActions.ITrialInstitutionLaboratoryPersonnelClearActionCreator;
    loadTrialInstitutionLaboratoryPersonnel: TrialInstitutionLaboratoryPersonnelActions.ITrialInstitutionLaboratoryPersonnelLoadByIdActionCreator;
    saveTrialInstitutionLaboratoryPersonnel: TrialInstitutionLaboratoryPersonnelActions.ITrialInstitutionLaboratoryPersonnelSaveActionCreator;
    createTrialInstitutionLaboratoryPersonnel: TrialInstitutionLaboratoryPersonnelActions.ITrialInstitutionLaboratoryPersonnelCreateActionCreator;
    validateTrialInstitutionLaboratoryPersonnel: TrialInstitutionLaboratoryPersonnelActions.ITrialInstitutionLaboratoryPersonnelValidateActionCreator;
    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;
    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;
}

const reduxFormName: string = "reduxForms.trialInstitutionLaboratoryPersonnel";

const TrialInstitutionLaboratoryPersonnelPage: FC<
    TrialInstitutionLaboratoryPersonnelPageProps
> = ({
    form,
    formState,
    formProperties,
    trialInstitutionLaboratoryPersonnel,
    lookups,
    loadingTrialInstitutionLaboratoryPersonnel,
    loadTrialInstitutionLaboratoryPersonnelFailure,
    loadTrialInstitutionLaboratoryPersonnelErrorCode,
    savingTrialInstitutionLaboratoryPersonnel,
    saveTrialInstitutionLaboratoryPersonnelSuccess,
    saveTrialInstitutionLaboratoryPersonnelFailure,
    creatingTrialInstitutionLaboratoryPersonnel,
    validatingTrialInstitutionLaboratoryPersonnel,
    validationFailures,
    permissions,
    clearTrialInstitutionLaboratoryPersonnel,
    loadTrialInstitutionLaboratoryPersonnel,
    saveTrialInstitutionLaboratoryPersonnel,
    createTrialInstitutionLaboratoryPersonnel,
    validateTrialInstitutionLaboratoryPersonnel,
    loadForm,
    changeForm,
    resetForm,
    setBreadcrumbs,
    setDrawerItems
}) => {
    //
    // -- Params --
    const { trialId } = useParams<{ trialId: string }>();
    const { trialInstitutionId } = useParams<{ trialInstitutionId: string }>();
    const { trialInstitutionLaboratoryId } = useParams<{ trialInstitutionLaboratoryId: string; }>();
    const { trialInstitutionLaboratoryPersonnelId } = useParams<{ trialInstitutionLaboratoryPersonnelId: string; }>();
    const trialIdNumber = parseInt(trialId, 10);
    const trialInstitutionIdNumber = parseInt(trialInstitutionId, 10);
    const trialInstitutionLaboratoryIdNumber = parseInt(trialInstitutionLaboratoryId, 10);
    const trialInstitutionLaboratoryPersonnelIdNumber = parseInt(trialInstitutionLaboratoryPersonnelId, 10);

    //
    // -- States --
    const [saveAndReturn, setSaveAndReturn] = useState<boolean>(false);
    const [formInitalised, setFormInitalised] = useState<boolean>(false);
    const [hasBeenSubmitted, setHasBeenSubmitted] = useState<boolean>(false);

    //
    // -- Hooks --
    const navigate = useNavigate();


    // Load Trial Institution Laboratory Personnel
    useEffect(() => {
        if (
            trialIdNumber &&
            trialInstitutionIdNumber &&
            trialInstitutionLaboratoryIdNumber &&
            trialInstitutionLaboratoryPersonnelIdNumber &&
            !trialInstitutionLaboratoryPersonnel
        ) {
            setDrawerItems(
                TrialInstitutionLabPersonnelSubMenu(
                    trialIdNumber,
                    trialInstitutionIdNumber,
                    trialInstitutionLaboratoryIdNumber,
                    trialInstitutionLaboratoryPersonnelIdNumber,
                    permissions
                )
            );
            setBreadcrumbs(
                TrialInstitutionLaboratoryPersonnelBreadcrumbs(
                    trialIdNumber,
                    trialInstitutionIdNumber,
                    trialInstitutionLaboratoryIdNumber,
                    trialInstitutionLaboratoryPersonnelIdNumber
                )
            );

            loadTrialInstitutionLaboratoryPersonnel(
                trialInstitutionLaboratoryPersonnelIdNumber
            );
        } else if (
            trialInstitutionLaboratoryIdNumber &&
            !trialInstitutionLaboratoryPersonnelIdNumber &&
            !trialInstitutionLaboratoryPersonnel
        ) {
            setBreadcrumbs(
                TrialInstitutionLaboratoryPersonnelCreateBreadcrumbs(
                    trialIdNumber,
                    trialInstitutionIdNumber,
                    trialInstitutionLaboratoryIdNumber
                )
            );
            setDrawerItems([]);
            createTrialInstitutionLaboratoryPersonnel(
                trialInstitutionLaboratoryIdNumber
            );
        } else if (trialInstitutionLaboratoryPersonnel && !formInitalised) {
            loadReduxForm();
            setFormInitalised(true);
        }
    }, [
        trialIdNumber,
        trialInstitutionIdNumber,
        trialInstitutionLaboratoryIdNumber,
        trialInstitutionLaboratoryPersonnelIdNumber,
        trialInstitutionLaboratoryPersonnel,
        formInitalised,
        setDrawerItems,
        TrialInstitutionLabPersonnelSubMenu,
        setBreadcrumbs,
        TrialInstitutionLaboratoryPersonnelBreadcrumbs,
        loadTrialInstitutionLaboratoryPersonnel,
        TrialInstitutionLaboratoryPersonnelCreateBreadcrumbs,
        createTrialInstitutionLaboratoryPersonnel,
        setFormInitalised,
    ]);

    // Navigate to error page on load failure
    useEffect(() => {
        if (loadTrialInstitutionLaboratoryPersonnelFailure) {
            navigate(
                `/error/${loadTrialInstitutionLaboratoryPersonnelErrorCode}`
            );
        }
    }, [loadTrialInstitutionLaboratoryPersonnelFailure, navigate]);

    // Update breadcrumbs
    useEffect(() => {
        if (
            trialIdNumber &&
            trialInstitutionIdNumber &&
            trialInstitutionLaboratoryIdNumber &&
            trialInstitutionLaboratoryPersonnelIdNumber &&
            trialInstitutionLaboratoryPersonnel
        ) {
            setBreadcrumbs(
                TrialInstitutionLaboratoryPersonnelBreadcrumbs(
                    trialIdNumber,
                    trialInstitutionIdNumber,
                    trialInstitutionLaboratoryIdNumber,
                    trialInstitutionLaboratoryPersonnelIdNumber,
                    trialInstitutionLaboratoryPersonnel
                        ?.trialInstitutionLaboratory?.trialInstitution?.trial
                        ?.studyAcronym,
                    trialInstitutionLaboratoryPersonnel
                        ?.trialInstitutionLaboratory?.trialInstitution
                        ?.institution?.name,
                    trialInstitutionLaboratoryPersonnel
                        ?.trialInstitutionLaboratory?.laboratory?.name,
                    trialInstitutionLaboratoryPersonnel?.personnel
                        ?.displayWithSalutation
                )
            );
        } else if (
            trialIdNumber &&
            trialInstitutionIdNumber &&
            trialInstitutionLaboratoryIdNumber &&
            !trialInstitutionLaboratoryPersonnelIdNumber &&
            trialInstitutionLaboratoryPersonnel
        ) {
            setBreadcrumbs(
                TrialInstitutionLaboratoryPersonnelCreateBreadcrumbs(
                    trialIdNumber,
                    trialInstitutionIdNumber,
                    trialInstitutionLaboratoryIdNumber,
                    trialInstitutionLaboratoryPersonnel
                        ?.trialInstitutionLaboratory?.trialInstitution?.trial
                        ?.displayName,
                    trialInstitutionLaboratoryPersonnel
                        ?.trialInstitutionLaboratory?.trialInstitution
                        ?.institution?.name,
                    trialInstitutionLaboratoryPersonnel
                        ?.trialInstitutionLaboratory?.laboratory?.name
                )
            );
        }
    }, [
        trialIdNumber,
        trialInstitutionIdNumber,
        trialInstitutionLaboratoryIdNumber,
        trialInstitutionLaboratoryPersonnelIdNumber,
        trialInstitutionLaboratoryPersonnel,
        setBreadcrumbs,
        TrialInstitutionLaboratoryPersonnelBreadcrumbs,
    ]);

    // Reload trial institution laboratory personnel after saving
    useEffect(() => {
        if (
            !savingTrialInstitutionLaboratoryPersonnel &&
            saveTrialInstitutionLaboratoryPersonnelSuccess
        ) {
            Alert.success(
                <NotificationAlert
                    alertContent={<span>Trial institution laboratory personnel saved successfully</span>}
                    icon={FontAwesomeIcons.Solid.CHECK}
                />
            );

            if (saveAndReturn) {
                navigate(
                    `/trials/${trialIdNumber}/trialinstitution/${trialInstitutionIdNumber}/labs/${trialInstitutionLaboratoryIdNumber}/personnel`
                );
            } else if (!trialInstitutionLaboratoryPersonnelIdNumber) {
                navigate(
                    `/trials/${trialIdNumber}/trialinstitution/${trialInstitutionIdNumber}/labs/${trialInstitutionLaboratoryIdNumber}/personnel/${trialInstitutionLaboratoryPersonnel?.id}/details`
                );
                clearTrialInstitutionLaboratoryPersonnel();
            } else {
                loadTrialInstitutionLaboratoryPersonnel(
                    trialInstitutionLaboratoryPersonnelIdNumber
                );
            }
        }
    }, [
        savingTrialInstitutionLaboratoryPersonnel,
        saveTrialInstitutionLaboratoryPersonnelSuccess,
        trialIdNumber,
        trialInstitutionIdNumber,
        trialInstitutionLaboratoryIdNumber,
        trialInstitutionLaboratoryPersonnelIdNumber,
        trialInstitutionLaboratoryPersonnel,
        clearTrialInstitutionLaboratoryPersonnel,
        loadTrialInstitutionLaboratoryPersonnel,
        saveAndReturn,
    ]);

    // Failed saving
    useEffect(() => {
        if (
            !savingTrialInstitutionLaboratoryPersonnel &&
            saveTrialInstitutionLaboratoryPersonnelFailure
        ) {
            Alert.error(
                <NotificationAlert
                    alertContent={renderRegistrationFormSaveBlock()}
                    icon={FontAwesomeIcons.Solid.BAN}
                />
            );
        }
    }, [
        savingTrialInstitutionLaboratoryPersonnel,
        saveTrialInstitutionLaboratoryPersonnelFailure,
    ]);

    // Cleanup effect to clear the laboratory personnel on component unmount
    useEffect(() => {
        return () => {
            clearTrialInstitutionLaboratoryPersonnel();
            resetForm(reduxFormName);
        };
    }, [clearTrialInstitutionLaboratoryPersonnel, resetForm, reduxFormName]);

    const handleOnSubmit = async (data: any) => {
        if (!hasBeenSubmitted) {
            setHasBeenSubmitted(true);
        }

        if (data) {
            let changes: Dtos.TrialInstitutionLaboratoryPersonnel =
                {} as Dtos.TrialInstitutionLaboratoryPersonnel;

            if (!data.trialInstitutionLaboratoryId) {
                changes.trialInstitutionLaboratoryId =
                    trialInstitutionLaboratoryIdNumber;
            }

            await saveTrialInstitutionLaboratoryPersonnel(
                Object.assign({ ...data }, changes)
            );

            if (data.saveAndReturn) {
                setSaveAndReturn(true);
            }
        }
    };

    const handleOnSubmitFailed = (_data: Dtos.LaboratoryPersonnel) => {
        Alert.error(
            <NotificationAlert
                alertContent={renderRegistrationFormSaveBlock()}
                icon={FontAwesomeIcons.Solid.BAN}
            />
        );
    };

    const onCancel = () => {
        navigate(
            `/trials/${trialIdNumber}/trialinstitution/${trialInstitutionIdNumber}/labs/${trialInstitutionLaboratoryIdNumber}/personnel`
        );
    };

    const loadReduxForm = () => {
        let extraData: Dtos.TrialInstitutionLaboratoryPersonnel =
            {} as Dtos.TrialInstitutionLaboratoryPersonnel;

        loadForm(
            reduxFormName,
            Object.assign({ ...trialInstitutionLaboratoryPersonnel }, extraData)
        );
    };

    // Debounce validation after the initial submit to clear form validation errors as the form get updated.
    useEffect(() => {
        const debounceValidate = debounce(async () => {
            let changes: Dtos.TrialInstitutionLaboratoryPersonnel =
                {} as Dtos.TrialInstitutionLaboratoryPersonnel;

            if (
                form &&
                hasBeenSubmitted &&
                !validatingTrialInstitutionLaboratoryPersonnel
            ) {
                await validateTrialInstitutionLaboratoryPersonnel(
                    Object.assign({ ...form }, changes)
                );
            }
        }, 250);

        debounceValidate();

        return () => {
            debounceValidate.cancel();
        };
    }, [form]);

    const personnelSearchLoader = useMemo(() => {
        return createPersonnelSearchLoader(
            form?.personnel 
                ? { label: form?.personnel?.displayWithSalutation, value: form?.personnelId } as Dtos.PersonnelOption 
                : null
        );
    }, [form]);

    const renderContent = useMemo(() => {
        const hasPermission: boolean =
            AuthenticationHelper.hasCreateEditPermissionFor(
                undefined,
                trialInstitutionLaboratoryPersonnelIdNumber,
                permissions,
                Dtos.Permission.LabPersonnelUpdate,
                Dtos.Permission.LabPersonnelCreate
            );
        const formDisabled: boolean =
            !hasPermission ||
            savingTrialInstitutionLaboratoryPersonnel ||
            (formState && formState.formStatus == Dtos.FormStatus.Disabled);

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            personnelDetails: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <h1>Personnel Details</h1>
                        <div className="card card-shadow">
                            <div className="form-row py-4 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "trialInstitutionLaboratoryPersonnel",
                                        {
                                            personnelId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                size: 2,
                                                inputType: SelectFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    value: form?.personnelId ?? null,
                                                    cacheOptions: true,
                                                    defaultOptions: form?.personnel
                                                        ? [{ label: form.personnel.displayWithSalutation, value: form.personnel.id }]
                                                        : true,
                                                    placeholder: "Type to search for personnel...",
                                                    clearable: true,
                                                    loadOptions: personnelSearchLoader,
                                                },
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-1",
                                                fieldClassName: "col-sm-11 generic-form-field mr-0 pr-0",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
            roleDetails: {
                type: RegistrationComponent.RegistrationElement,
                component: (
                    <>
                        <br />
                        <h1>Role Details</h1>
                        <div className="card card-shadow">
                            <div className="form-row pt-4 pb-2 px-4">
                                <div className="col-md-12">
                                    {renderFormControls(
                                        form,
                                        "trialInstitutionLaboratoryPersonnel",
                                        {
                                            roleId: {
                                                type: RegistrationComponent.RegistrationControl,
                                                size: 2,
                                                inputType: SelectFormInput,
                                                inputDisabled: formDisabled,
                                                inputProps: {
                                                    options:
                                                        generateOptionsFromLookup(
                                                            findLookup(
                                                                "trialInstitutionLaboratoryPersonnel",
                                                                "roleId",
                                                                lookups
                                                            ),
                                                            form.roleId
                                                        ),
                                                },
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-1",
                                                fieldClassName: "col-sm-11 generic-form-field mr-0 pr-0",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                            <div className="form-row pt-2 pb-4 px-4">
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "trialInstitutionLaboratoryPersonnel",
                                        {
                                            dateStarted: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: DatePickerFormInputFabric,
                                                inputDisabled: formDisabled,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-2",
                                                fieldClassName: "col-sm-9 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                                <div className="col-md-6">
                                    {renderFormControls(
                                        form,
                                        "trialInstitutionLaboratoryPersonnel",
                                        {
                                            dateCeased: {
                                                type: RegistrationComponent.RegistrationControl,
                                                inputType: DatePickerFormInputFabric,
                                                inputDisabled: formDisabled || !form.personnelId,
                                                groupClassName: "form-row bottom-0 border-top-0 pb-0 pt-0",
                                                labelClassName: "col-form-label col-sm-2",
                                                fieldClassName: "col-sm-10 generic-form-field",
                                            },
                                        },
                                        lookups,
                                        validationFailures,
                                        formProperties,
                                        changeForm
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                ),
            },
        };

        return (
            <Form
                model={reduxFormName}
                onSubmit={(val, _event) => handleOnSubmit(val)}
                onSubmitFailed={(val) => handleOnSubmitFailed(val)}
            >
                {renderFormControls(
                    form,
                    "trialInstitutionLaboratoryPersonnel",
                    formComponents,
                    lookups,
                    validationFailures,
                    formProperties,
                    changeForm
                )}
                <div className="mt-4 mb-4 text-right">
                    <button
                        disabled={formDisabled}
                        onClick={() => {
                            changeForm(reduxFormName + ".saveAndReturn", false);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit
                    </button>
                    <button
                        disabled={formDisabled}
                        onClick={() => {
                            changeForm(reduxFormName + ".saveAndReturn", true);
                        }}
                        type="submit"
                        className="btn btn-primary mr-2"
                    >
                        Submit And Return
                    </button>
                    <button onClick={onCancel} className="btn btn-primary mr-2">
                        Cancel
                    </button>
                </div>
            </Form>
        );
    }, [
        AuthenticationHelper,
        trialInstitutionLaboratoryIdNumber,
        permissions,
        savingTrialInstitutionLaboratoryPersonnel,
        formState,
        handleOnSubmit,
        handleOnSubmitFailed,
        renderFormControls,
        lookups,
        validationFailures,
        formProperties,
        form,
        changeForm,
        reduxFormName,
        onCancel,
        personnelSearchLoader
    ]);

    return (
        <RestrictedLayout
            permission={Dtos.Permission.LabPersonnelView}
            loading={
                loadingTrialInstitutionLaboratoryPersonnel ||
                savingTrialInstitutionLaboratoryPersonnel ||
                creatingTrialInstitutionLaboratoryPersonnel
            }
        >
            {renderContent}
        </RestrictedLayout>
    );
};

const mapStateToProps = (
    state: ITmdState
): Partial<TrialInstitutionLaboratoryPersonnelPageProps> => {
    let trialInstitutionLaboratoryPersonnel:
        | Dtos.TrialInstitutionLaboratoryPersonnel
        | undefined = !(
        state.trialInstitutionLaboratoryPersonnel.formData instanceof Array
    )
        ? state.trialInstitutionLaboratoryPersonnel.formData
        : undefined;
    let permissions = state.user.userSummary
        ? state.user.userSummary.permissions
        : [];

    return {
        trialInstitutionLaboratoryPersonnel:
            trialInstitutionLaboratoryPersonnel!,
        loadingTrialInstitutionLaboratoryPersonnel:
            state.trialInstitutionLaboratoryPersonnel.loadState &&
            state.trialInstitutionLaboratoryPersonnel.loadState.status ==
                RequestState.Pending,
        loadTrialInstitutionLaboratoryPersonnelSuccess:
            state.trialInstitutionLaboratoryPersonnel.loadState &&
            state.trialInstitutionLaboratoryPersonnel.loadState.status ==
                RequestState.Success,
        loadTrialInstitutionLaboratoryPersonnelFailure:
            state.trialInstitutionLaboratoryPersonnel.loadState &&
            state.trialInstitutionLaboratoryPersonnel.loadState.status ==
                RequestState.Failure,
        loadTrialInstitutionLaboratoryPersonnelErrorCode:
            state.trialInstitutionLaboratoryPersonnel.loadState.errorCode,
        savingTrialInstitutionLaboratoryPersonnel:
            state.trialInstitutionLaboratoryPersonnel.saveState &&
            state.trialInstitutionLaboratoryPersonnel.saveState.status ==
                RequestState.Pending,
        saveTrialInstitutionLaboratoryPersonnelSuccess:
            state.trialInstitutionLaboratoryPersonnel.saveState &&
            state.trialInstitutionLaboratoryPersonnel.saveState.status ==
                RequestState.Success,
        saveTrialInstitutionLaboratoryPersonnelFailure:
            state.trialInstitutionLaboratoryPersonnel.saveState &&
            state.trialInstitutionLaboratoryPersonnel.saveState.status ==
                RequestState.Failure,
        creatingTrialInstitutionLaboratoryPersonnel:
            state.trialInstitutionLaboratoryPersonnel.createState &&
            state.trialInstitutionLaboratoryPersonnel.createState.status ==
                RequestState.Pending,
        createTrialInstitutionLaboratoryPersonnelSuccess:
            state.trialInstitutionLaboratoryPersonnel.createState &&
            state.trialInstitutionLaboratoryPersonnel.createState.status ==
                RequestState.Success,
        createTrialInstitutionLaboratoryPersonnelFailure:
            state.trialInstitutionLaboratoryPersonnel.createState &&
            state.trialInstitutionLaboratoryPersonnel.createState.status ==
                RequestState.Failure,
        validatingTrialInstitutionLaboratoryPersonnel:
            state.trialInstitutionLaboratoryPersonnel.validateState &&
            state.trialInstitutionLaboratoryPersonnel.validateState.status ==
                RequestState.Pending,
        user: state.user.data,
        permissions: permissions,
        lookups: state.trialInstitutionLaboratoryPersonnel.lookups,
        form: state.reduxForms.trialInstitutionLaboratoryPersonnel,
        formState: state.trialInstitutionLaboratoryPersonnel.formState,
        formProperties:
            state.trialInstitutionLaboratoryPersonnel.formProperties,
        reduxFormState:
            state.reduxForms.formState.trialInstitutionLaboratoryPersonnel,
        validationFailures: trialInstitutionLaboratoryPersonnel
            ? state.trialInstitutionLaboratoryPersonnel.validationFailures
            : undefined,
    };
};

const mapDispatchToProps = (
    dispatch
): Partial<TrialInstitutionLaboratoryPersonnelPageProps> => {
    return {
        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),
        loadTrialInstitutionLaboratoryPersonnel: bindActionCreators(
            TrialInstitutionLaboratoryPersonnelActions.LoadTrialInstitutionLaboratoryPersonnelById,
            dispatch
        ),
        clearTrialInstitutionLaboratoryPersonnel: bindActionCreators(
            TrialInstitutionLaboratoryPersonnelActions.Clear,
            dispatch
        ),
        saveTrialInstitutionLaboratoryPersonnel: bindActionCreators(
            TrialInstitutionLaboratoryPersonnelActions.SaveTrialInstitutionLaboratoryPersonnel,
            dispatch
        ),
        createTrialInstitutionLaboratoryPersonnel: bindActionCreators(
            TrialInstitutionLaboratoryPersonnelActions.CreateTrialInstitutionLaboratoryPersonnel,
            dispatch
        ),
        validateTrialInstitutionLaboratoryPersonnel: bindActionCreators(
            TrialInstitutionLaboratoryPersonnelActions.ValidateTrialInstitutionLaboratoryPersonnel,
            dispatch
        ),
        setBreadcrumbs: bindActionCreators(
            NavigationActions.SetBreadcrumbs,
            dispatch
        ),
        setDrawerItems: bindActionCreators(
            NavigationActions.SetDrawerItems,
            dispatch
        )
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TrialInstitutionLaboratoryPersonnelPage);
